import React from "react";
import Icon from "@bonprix/pattern-library/templates/icon";

export default function Option({
  className = "input",
  value,
  custom,
  children,
  onClick,
  icon,
  disabled,
  attributes = {},
  testRefs = {},
  inputRef,
  active,
}) {
  if (custom) {
    const click = (icon, disabled) => {
      onClick?.(icon, disabled);
      setTimeout(() => inputRef?.current?.blur(), 100);
    };

    const currentClassName =
      "input-group__select-option" +
      (icon ? " has-icon" : "") +
      (disabled ? " line-through" : "") +
      (active ? " is-active" : "");

    return (
      <div
        className={currentClassName}
        onClick={() => click(icon, disabled)}
        {...attributes}
        {...testRefs}
      >
        {icon && (
          <Icon name={icon} className="input-group__select-option-icon" />
        )}
        <span className="input-group__select-option-inner">{children}</span>
      </div>
    );
  }

  return (
    <option value={value} className={className} {...attributes} {...testRefs}>
      {children}
    </option>
  );
}
